// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
import {
     AppstoreOutlined, MailOutlined, SettingOutlined, MenuUnfoldOutlined, MenuFoldOutlined, ToolOutlined, DeleteOutlined, DragOutlined,
     FontSizeOutlined,
     BarcodeOutlined,
     BorderOutlined,
     LineOutlined,
     QrcodeOutlined,
     MinusCircleOutlined,
     DownloadOutlined

} from '@ant-design/icons';
import { Flex, Button, Menu, Layout, Result, FloatButton, ConfigProvider, Affix, Tabs, Space, Table, Tag, InputNumber, Input, ColorPicker, Tree, Col, Row, Slider, QRCode } from 'antd';
import Card from "./components/Card";

//import SVG from 'svg';
//import {Document, Pdf} from 'react-pdf';
import ReactPDF, { BlobProvider, Document, Page, Text, View, StyleSheet, Svg, PDFViewer, pdf, usePDF, PDFDownloadLink, Rect, Circle, G, Path, Image } from '@react-pdf/renderer';
//import { Document, Page, pdf } from '@react-pdf/renderer';

import SvgComponent, {  Etiqueta01, Etiqueta02, Etiqueta03, InputProp } from "./components/EtiquetasModels";
//import { Path } from "three";
//import Page from "react-pdf/dist/cjs/Page";

const { Header, Footer, Sider, Content } = Layout;

const styles = StyleSheet.create({
     page: {
          flexDirection: 'row',
          backgroundColor: '#E4E4E4',
     },
     section: {
          margin: 10,
          padding: 10,
          flexGrow: 1,
     },
     page2: {
          backgroundColor: 'white',
          padding: 20,
     },
     rectangle: {
          position: 'absolute',
          top: 100,
          left: 100,
          width: 200,
          height: 100,
          border: '1px solid black', // Borda do retângulo
     },
     CutContour: {
          strokeColor: '#FF0000',
          strokeWidth: 1,
          dash: [3, 3]
          // position: 'absolute',
          // top: 100,
          // left: 100,
          // width: 200,
          // height: 0, // Altura 0 para criar uma linha
          // borderBottom: '2px solid #FF00FF', // Linha de corte em CutContour (magenta)
          // fill: 'none', // Sem preenchimento
     },
     text: {
          marginTop: 220,
          fontSize: 24,
          fontWeight: 'bold',
     },
});





const getFieldType = (field) => {
     switch (field) {
          case "width":
          case "height":
          case "x":
          case "y":
          case "cx":
          case "cy":
          case "r":
          case "stroke-width":
          case "font-size":
               return "number"
          case "fill":
          case "stroke":
               return "color"
          default:
               return "string";
     }
}

const svgModels = [
     {
          "key": 1,
          "title": "Exemplo 01",
          "standard": true,
          "id": "",
          "info": `<svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg"><rect  id="REC1" name="REC1" width="200" height="100" x="0" y="0" fill="white" stroke-width="1" stroke="black" /><rect id="REC2" name="REC2"  width="190" height="35" x="5" y="5" fill="white" stroke-width="1" stroke="black" /><rect id="REC3" name="REC3"  width="190" height="50" x="5" y="45" fill="white" stroke-width="1" stroke="black" /><text  id="TXT1" name="TXT1" x="100" y="25" fill="black" text-anchor="middle" font-family="sans-serif" font-weight="bold">Product 01</text><text  id="TXT2" name="TXT2" x="100" y="75" fill="black" text-anchor="middle">$ 5.99</text></svg>`
     },
     {
          "key": 2,
          "title": "Exemplo 02",
          "standard": true,
          "id": "",
          "info": `<svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg">
			<rect id="REC1" name="REC1"  width="200" height="100" x="0" y="0" fill="white" strokeWidth="1" stroke="red" />
			<rect id="REC2" name="REC2"  width="190" height="35" x="5" y="5" fill="white" strokeWidth="1" stroke="red" />
			<rect id="REC3" name="REC3"  width="190" height="50" x="5" y="45" fill="white" strokeWidth="1" stroke="red" />
			<text  id="TXT1" name="TXT1" x="100" y="25" fill="red" text-anchor="middle" font-family="Cursive" font-weight="bold">Product 02</text>
			<svg id="SVG2" name="SVG2" x="75" y="45" height="50" width="50" viewBox="0 0 25 25" role="img"><path fill="transparent" d="M0,0 h25v25H0z" shapeRendering="crispEdges"></path><path fill="rgba(0, 0, 0, 0.88)" d="M0 0h7v1H0zM8 0h2v1H8zM11 0h5v1H11zM18,0 h7v1H18zM0 1h1v1H0zM6 1h1v1H6zM10 1h6v1H10zM18 1h1v1H18zM24,1 h1v1H24zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM8 2h1v1H8zM10 2h1v1H10zM12 2h1v1H12zM15 2h1v1H15zM18 2h1v1H18zM20 2h3v1H20zM24,2 h1v1H24zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM8 3h2v1H8zM15 3h1v1H15zM18 3h1v1H18zM20 3h3v1H20zM24,3 h1v1H24zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM10 4h1v1H10zM12 4h1v1H12zM14 4h3v1H14zM18 4h1v1H18zM20 4h3v1H20zM24,4 h1v1H24zM0 5h1v1H0zM6 5h1v1H6zM8 5h1v1H8zM11 5h1v1H11zM15 5h2v1H15zM18 5h1v1H18zM24,5 h1v1H24zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18,6 h7v1H18zM8 7h1v1H8zM14 7h3v1H14zM1 8h1v1H1zM3 8h1v1H3zM5 8h8v1H5zM15 8h5v1H15zM21 8h2v1H21zM24,8 h1v1H24zM0 9h3v1H0zM7 9h1v1H7zM9 9h2v1H9zM16 9h3v1H16zM24,9 h1v1H24zM4 10h1v1H4zM6 10h2v1H6zM16 10h2v1H16zM20 10h1v1H20zM23,10 h2v1H23zM0 11h1v1H0zM2 11h2v1H2zM8 11h1v1H8zM11 11h2v1H11zM14 11h1v1H14zM18 11h3v1H18zM0 12h2v1H0zM4 12h4v1H4zM10 12h3v1H10zM17 12h2v1H17zM21 12h1v1H21zM23,12 h2v1H23zM1 13h2v1H1zM5 13h1v1H5zM7 13h1v1H7zM9 13h1v1H9zM11 13h1v1H11zM18 13h2v1H18zM21 13h2v1H21zM24,13 h1v1H24zM0 14h1v1H0zM2 14h2v1H2zM6 14h2v1H6zM9 14h1v1H9zM11 14h1v1H11zM18 14h3v1H18zM22 14h1v1H22zM24,14 h1v1H24zM1 15h1v1H1zM3 15h3v1H3zM7 15h1v1H7zM9 15h2v1H9zM13 15h1v1H13zM15 15h3v1H15zM20 15h1v1H20zM23 15h1v1H23zM0 16h3v1H0zM4 16h1v1H4zM6 16h1v1H6zM9 16h1v1H9zM12 16h1v1H12zM14 16h1v1H14zM16 16h7v1H16zM8 17h1v1H8zM10 17h1v1H10zM12 17h5v1H12zM20 17h2v1H20zM24,17 h1v1H24zM0 18h7v1H0zM8 18h3v1H8zM14 18h3v1H14zM18 18h1v1H18zM20 18h2v1H20zM23,18 h2v1H23zM0 19h1v1H0zM6 19h1v1H6zM8 19h2v1H8zM13 19h1v1H13zM16 19h1v1H16zM20 19h3v1H20zM24,19 h1v1H24zM0 20h1v1H0zM2 20h3v1H2zM6 20h1v1H6zM9 20h1v1H9zM11 20h3v1H11zM16 20h6v1H16zM23,20 h2v1H23zM0 21h1v1H0zM2 21h3v1H2zM6 21h1v1H6zM8 21h2v1H8zM11 21h1v1H11zM15 21h1v1H15zM17 21h1v1H17zM19 21h4v1H19zM0 22h1v1H0zM2 22h3v1H2zM6 22h1v1H6zM9 22h5v1H9zM15 22h1v1H15zM19 22h2v1H19zM22 22h1v1H22zM24,22 h1v1H24zM0 23h1v1H0zM6 23h1v1H6zM8 23h1v1H8zM10 23h1v1H10zM13 23h1v1H13zM15 23h4v1H15zM21 23h1v1H21zM0 24h7v1H0zM14 24h3v1H14zM19 24h1v1H19zM23,24 h2v1H23z" shapeRendering="crispEdges"></path></svg>
		</svg>`
     },
     {
          "key": 3,
          "title": "Exemplo 03",
          "standard": true,
          "id": "",
          "info": `<svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg">
			<rect id="REC1" name="REC1" width="200" height="100" x="0" y="0" fill="#FFFFFF" stroke-width="1" stroke="#0000FF" />
			<rect id="REC2" name="REC2" width="190" height="35" x="5" y="5" fill="#FFFFFF" stroke-width="1" stroke="#0000FF" />
			<rect id="REC3" name="REC3" width="190" height="50" x="5" y="45" fill="#FFFFFF" stroke-width="1" stroke="#0000FF" />
			<text id="TXT1" name="TXT1" x="100" y="25" fill="#0000FF" text-anchor="middle" font-family="Arial, Helvetica, sans-serif">Product 03</text>
			<text id="TXT2" name="TXT2" x="100" y="70" fill="#0000FF" text-anchor="middle" font-size="35" alignment-baseline="central" font-family="Arial, Helvetica, sans-serif">$ 5.99</text>
               <g id="G1" name="G1">
                    <circle id="CIR1" name="CIR1" cx="20" cy="20" r="10" stroke="black" stroke-width="2" fill="#0000FF" />
               </g>
		</svg>`
     },
     {
          "key": 4,
          "title": "Exemplo 04",
          "standard": true,
          "id": "",
          "info": `<svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg">
			<rect id="REC1" name="REC1" width="200" height="100" x="0" y="0" fill="#FFFFFF" stroke-width="1" stroke="#0000FF" />
			<rect id="REC2" name="REC2" width="190" height="35" x="5" y="5" fill="#FFFFFF" stroke-width="1" stroke="#0000FF" />
			<rect id="REC3" name="REC3" width="190" height="50" x="5" y="45" fill="#FFFFFF" stroke-width="1" stroke="#0000FF" />
			<text id="TXT1" name="TXT1" x="100" y="25" fill="#0000FF" text-anchor="middle" font-family="Arial, Helvetica, sans-serif">Product 04</text>
			<text id="TXT2" name="TXT2" x="100" y="70" fill="#0000FF" text-anchor="middle" font-size="35" alignment-baseline="central" font-family="Arial, Helvetica, sans-serif">$ 9.99</text>
		</svg>`
     },
];

//let QRCode = require('./lib/qrcode.js');
let JsBarcode = require('jsbarcode');

const { DOMImplementation, XMLSerializer } = require('xmldom');
const xmlSerializer = new XMLSerializer();
const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

// JsBarcode(svgNode, 'test', {
//     xmlDocument: document,
// });
// const svgText = xmlSerializer.serializeToString(svgNode);

const SvgComponent2 = () => {
     return (
          <Svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg">
               <Rect id="REC1" name="REC1" width="200" height="100" x="0" y="0" fill="#FFFFFF" strokeWidth="1" stroke="#0000FF" />
               <Rect id="REC2" name="REC2" width="190" height="35" x="5" y="5" fill="#FFFFFF" strokeWidth="1" stroke="#0000FF" />
               <Rect id="REC3" name="REC3" width="190" height="50" x="5" y="45" fill="#FFFFFF" strokeWidth="1" stroke="#0000FF" />
               <Text id="TXT1" name="TXT1" x="100" y="25" fill="#0000FF" textAnchor="middle">Product 03</Text>
               <Text id="TXT2" name="TXT2" x="100" y="70" fill="#0000FF" textAnchor="middle" fontSize="36" alignmentBaseline="central" style="font-family: 'Super Sans'; font-weight:normal;
                  font-style: italic">$ 5.99</Text>
               <G id="G1" name="G1">
                    <Circle id="CIR1" name="CIR1" cx="20" cy="20" r="10" stroke="black" strokeWidth="2" fill="#0000FF" />
               </G>

               {/* <Path d="M0 0 L200 0 L200 100 L0 100 Z" stroke="CutContour" stroke-width="0.25" fill="none" />
               <Path d="M0 0 L200 0 L200 100 L0 100 Z" stroke="CutContour" stroke-width="0.25" fill="CutContour" />

               <color-profile id="CutContour" src="CutContour.icc" />

               <Path d="M0 0 L200 0 L200 100 L0 100 Z" fillRule="evenodd" strokeWidth="0.25" fill="#008FCD icc-named-color(GraphColors, 'CutContour')" />
               <Path d="M0 0 L200 0 L200 100 L0 100 Z" fillRule="evenodd" strokeWidth="0.25" fill="rgb-icc(#Separation, 'CutContour')" />
               <Path d="M0 0 L200 0 L200 100 L0 100 Z" fillRule="evenodd" strokeWidth="0.25" fill="none rgb-icc(#Separation, 'CutContour')" color="CutContour" stroke="rgb(0,255,0) icc-color(#CMYK, 26%, 50%, 99%, 24%)" />
               <Path d="M0 0 L200 0 L200 100 L0 100 Z" fillRule="evenodd" strokeWidth="0.25" fill="none" color="CutContour" stroke="rgb(0,255,0) icc-color(#CMYK, 26%, 50%, 99%, 24%)" />
               <Path d="M0 0 L200 0 L200 100 L0 100 Z" fillRule="evenodd" fill="none" stroke="rgb(0,255,0) icc-color(#CMYK, 26%, 50%, 99%, 24%)" strokeWidth="0.5916" stroke-miterlimit="3.8637" /> */}

          </Svg>
     );
};




function GerarCódigoDeBarras(txt) {
     let configuracao = {
          //format: "pharmacode",
          lineColor: "#0aa",
          width: 4,
          height: 40,
          displayValue: true,
          valid: function (valido) {
               if (valido) {
                    //document.getElementById("mensagem").innerHTML = "";
                    //console.log("OK")
               } else {
                    //document.getElementById("mensagem").innerHTML = "Valor invalido";
                    //console.log("Valor inválido")
               }
          }
     };
     JsBarcode(svgNode, txt, configuracao);
     const svgText = xmlSerializer.serializeToString(svgNode);

     //console.log(svgText);
}

GerarCódigoDeBarras('1234')

const headerStyle = {
     textAlign: 'center',
     height: 64,
     lineHeight: '64px',
     padding: 0,
     border: '1px solid #006EDF',
     backgroundColor: '#FFFFFF',
};
const contentStyle = {
     //textAlign: 'center',
     minHeight: 120,
     lineHeight: '120px',
     color: '#000000',
     backgroundColor: '#D3D3D3',
     border: '1px solid #006EDF',
     overflow: 'scroll'
};
// const siderStyle = {
//      textAlign: 'center',
//      lineHeight: '120px',
//      color: '#000000',
//      backgroundColor: '#FFFFFF',
//      border: '1px solid #006EDF'
// };
const footerStyle = {
     textAlign: 'center',
     color: '#000000',
     backgroundColor: '#FFFFFF',
     border: '1px solid #006EDF'
};

const tab_style = {
     backgroundColor: '#FFFFFF',
     width: '100%',
     height: '100%',
     // border: '1px solid #006EDF'
}


let dragX = 0;
let dragY = 0;

const TLSEtiquetas = () => {

     window.scrollTo(0, 0);
     //const [current_page, setCurrentPage] = useState("Home");
     const [svgNodes, setSvgNodes] = useState<any>(null);
     const [svgString, setSvgString] = useState(`<svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg"></svg>`);
     //const [current_component, setCurrentComponent] = useState('Home');
     const [current, setCurrent] = useState('1');
     const [svg_elements_tab, setSvgElementsTab] = useState<any[]>([]);
     const [properties_tab, setPropertiesTab] = useState<any[]>([]);
     const [collapsed, setCollapsed] = useState(true);
     const [broken, setBroken] = useState<any>(null);
     const [full_view, setFullView] = useState(false);
     const [svg, setSvg] = useState<any>(null);
     const [svgCode, setSvgCode] = useState('');
     const [selectedElement, setSelectedElement] = useState<any[]>([]);
     const [dragging, setDragging] = useState(false);
     const [enable_drag, setEnableDrag] = useState(false);
     const [inputValue, setInputValue] = useState(1);

     const myElementRef = useRef(null);

     const handleUpdatePage = (Model) => {
          setCurrent('3')
          setSvgString(Model);
          setInputValue(1)
     };

     useEffect(() => {
          const parseSvgString = (svg) => {
               const parser = new DOMParser();
               const doc = parser.parseFromString(svg, 'image/svg+xml');
               return doc.documentElement; // Retorna o elemento raiz do SVG
          };

          const nodes = parseSvgString(svgString);
          setSvgNodes(nodes);
          //console.log(nodes);

     }, [svgString]);

     useEffect(() => {
          handleTraverse();

     }, [svgNodes]);

     // useEffect(() => {
     //      setCurrentComponent(() => { return current_page })
     // }, [current_page]);

     useEffect(() => {
          updateProperties();
     }, [selectedElement]);

     let treeInfo = [];
     let idx = 0;
     const traverseNodes = (node, arr, start) => {

          if (node.nodeName != "svg" && node.nodeName != "#text") {
               //console.log(`Node: ${node.nodeName}, Attributes: ${node.attributes?.length > 0 ? Array.from(node.attributes).map(attr => `${attr.name}="${attr.value}"`).join(', ') : 'None'}`);
               arr.children.push({
                    "key": idx,
                    "title": (<>{node.getAttribute("name") || node.getAttribute("id")} <a onClick={() => { deleteOneElement(node.getAttribute("id")) }}><DeleteOutlined style={{ color: '#FF0000' }} /></a></>),
                    "id": node.getAttribute("id"),
                    "name": node.getAttribute("name"),

                    children: []
               })
               idx++;
          } else if (node.nodeName == "#text") {
               //console.log('text info', node);
          }

          // Percorrer todos os filhos do nó atual
          for (let i = 0; i < node.childNodes.length; i++) {
               if (node.nodeName != "#text") {
                    traverseNodes(node.childNodes[i], start == true ? arr : arr.children[arr.children.length - 1], false); // Chamada recursiva para cada filho
               }
          }
     };

     const handleTraverse = () => {

          idx = 0;
          treeInfo = [];
          if (svgNodes) {

               treeInfo.push({
                    "key": idx,
                    "title": svgNodes.getAttribute("name") || svgNodes.getAttribute("id"),
                    "id": svgNodes.getAttribute("id"),
                    "name": svgNodes.getAttribute("name"),
                    children: []
               })
               idx++;
               traverseNodes(svgNodes, treeInfo[0], true); // Iniciar a travessia a partir do nó SVG
          }
          setSvgElementsTab(treeInfo);
     };

     const selectElement = (el) => {
          let sel_items = [];
          sel_items.push(el)
          setSelectedElement(sel_items);
     }

     const deleteOneElement = (elID) => {
          const svgElement = svgNodes.getElementById(elID);
          if (svgElement) {
               svgElement.remove();
          }
          handleTraverse();
     }

     const updatePropInputColor = (value, name) => {
          let temp_nodes = svgNodes;
          const svgElement = temp_nodes.getElementById(selectedElement[0]);
          if (svgElement) {
               for (let i = 0; i < properties_tab.length; i++) {
                    if (properties_tab[i].property == name) {
                         if (properties_tab[i].property == "text") {
                              svgElement.innerHTML = value?.toHexString();
                         } else {
                              svgElement.setAttribute(properties_tab[i].property, value?.toHexString());
                         }
                    }
               }
               setSvgNodes(temp_nodes);
               updateProperties();
          }
          handleTraverse();
     }

     const updatePropInputNumber = (value, name) => {
          let temp_nodes = svgNodes;
          const svgElement = temp_nodes.getElementById(selectedElement[0]);
          if (svgElement) {
               for (let i = 0; i < properties_tab.length; i++) {
                    if (properties_tab[i].property == name) {
                         if (properties_tab[i].property == "text") {
                              svgElement.innerHTML = value;
                         } else {
                              svgElement.setAttribute(properties_tab[i].property, value);
                         }
                    }

               }
               setSvgNodes(temp_nodes);
               updateProperties();
          }
          handleTraverse();
     }

     const updatePropInput = (e) => {
          let temp_nodes = svgNodes;
          const svgElement = temp_nodes.getElementById(selectedElement[0]);
          if (svgElement) {
               for (let i = 0; i < properties_tab.length; i++) {
                    if (properties_tab[i].property == e.target.name) {
                         if (properties_tab[i].property == "text") {
                              svgElement.innerHTML = e.target.value;
                         } else {
                              svgElement.setAttribute(properties_tab[i].property, e.target.value);
                         }
                    }
               }
               setSvgNodes(temp_nodes);
               updateProperties();
          }
          handleTraverse();
     }

     const handleElementDelete = () => {
          if (selectedElement.length > 0) {
               for (let i = 0; i < selectedElement.length; i++) {
                    const svgElement = document.getElementById(selectedElement[i].id);
                    if (svgElement) {
                         svgElement.remove();
                    }
               }
               setSelectedElement([]);
               setPropertiesTab([]);
          }
     };

     const novoSVG = () => {
          setSvgString(`<svg id="SVG1" name="SVG1" width="200" height="100" xmlns="http://www.w3.org/2000/svg"></svg>`)
     };

     const addRectSVG = () => {

          if (svgNodes) {

               let rectID = 1;
               let rect = svgNodes.getElementById("REC" + rectID.toString())
               while (rect != null) {
                    rectID++;
                    rect = svgNodes.getElementById("REC" + rectID.toString())
               }

               const parser = new DOMParser();
               const doc = parser.parseFromString(`<rect id="REC${rectID}" name="REC${rectID}" width="200" height="100" x="0" y="0" fill="#FFFFFF" stroke-width="1" stroke="#000000" />`, 'image/svg+xml');
               const newRect = doc.documentElement; // Retorna o elemento raiz do SVG

               // Inserir o retângulo como o primeiro filho do SVG
               svgNodes.insertBefore(newRect, null);

               // Atualizar o estado para re-renderizar
               setSvgNodes(svgNodes.cloneNode(true)); // Clona o nó SVG atualizado
          }
          updateProperties();
          handleTraverse();
     };

     const addCircleSVG = () => {

          if (svgNodes) {

               let circID = 1;
               let circ = svgNodes.getElementById("CIR" + circID.toString())
               while (circ != null) {
                    circID++;
                    circ = svgNodes.getElementById("CIR" + circID.toString())
               }

               const parser = new DOMParser();
               const doc = parser.parseFromString(`<circle id="CIR${circID}" name="CIR${circID}" r="15" cx="20" cy="20" fill="#FFFFFF" stroke-width="1" stroke="#000000" />`, 'image/svg+xml');
               const newCir = doc.documentElement; // Retorna o elemento raiz do SVG

               // Inserir o retângulo como o primeiro filho do SVG
               svgNodes.insertBefore(newCir, null);

               // Atualizar o estado para re-renderizar
               setSvgNodes(svgNodes.cloneNode(true)); // Clona o nó SVG atualizado
          }
          updateProperties();
          handleTraverse();
     };

     const addTextSVG = () => {

          if (svgNodes) {

               let txtID = 1;
               let txt = svgNodes.getElementById("TXT" + txtID.toString())
               while (txt != null) {
                    txtID++;
                    txt = svgNodes.getElementById("TXT" + txtID.toString())
               }

               const parser = new DOMParser();
               const doc = parser.parseFromString(`<text id="TXT${txtID}" name="TXT${txtID}" x="100" y="70" fill="#000000" text-anchor="middle" font-size="35" alignment-baseline="central">Texto</text>`, 'image/svg+xml');
               const newTxt = doc.documentElement; // Retorna o elemento raiz do SVG

               // Inserir o retângulo como o primeiro filho do SVG
               svgNodes.insertBefore(newTxt, null);

               // Atualizar o estado para re-renderizar
               setSvgNodes(svgNodes.cloneNode(true)); // Clona o nó SVG atualizado
          }
          updateProperties();
          handleTraverse();
     };

     const addGSVG = () => {

          const svgElement2 = svg.select(`#${svg_elements_tab[0].children[0].title}`);
          let node_el = svg.nested().attr({ x: 100, y: 100 }).add(svgElement2.members[0]);

          //const svgElement = svg.select(`#${selectedElement[i].id}`);
          console.log(node_el.node.childNodes);
          const svgElement = document.getElementById(svg_elements_tab[0].children[0].title);
          //const svgElement2 = svg.select(`#${properties_tab.svg_elements[0].children[0].title}`);

          //console.log(svgElement);
          console.log(svgElement2.members[0]);
          console.log(node_el);

          //console.log('find',svg.find("#"+properties_tab.svg_elements[0].children[0].title));
          //console.log(svgElement.members[0].node);
          if (svgElement) {
               //svgElement.addTo(node_el);
               //console.log(svgElement.members[0].node);
               //node_el.add(svgElement)
               //node_el.add(svgElement2.members[0])
               node_el.node.appendChild(svgElement2.members[0].node);
          }
          updateProperties();
          handleTraverse();
     };

     const items = [
          {
               label: 'Arquivo',
               key: '1',
               children: [
                    {
                         label: (<div onClick={() => { novoSVG() }}>Novo</div>),
                         key: '2'
                    },
                    {
                         label: 'Abrir',
                         key: '3'
                    },
                    {
                         label: 'Salvar',
                         key: '4'
                    },
               ]
          },
          {
               label: 'Editar',
               key: '6',
               children: [
                    {
                         label: 'Copiar',
                         key: '7'
                    },
                    {
                         label: 'Colar',
                         key: '8'
                    },
                    {
                         label: 'Selecionar tudo',
                         key: '9'
                    },
                    {
                         label: 'Remover seleção',
                         key: '10'
                    },
                    {
                         label: (<div onClick={handleElementDelete} >Excluír</div>),
                         key: '11'
                    },

                    {
                         label: (<div onClick={addRectSVG}>Adicionar retângulo</div>),
                         key: '12'
                    },
                    {
                         label: (<div onClick={addCircleSVG} >Adicionar círculo</div>),
                         key: '13'
                    },
                    {
                         label: (<div onClick={addTextSVG} >Adicionar texto</div>),
                         key: '14'
                    },
                    {
                         label: (<div onClick={addGSVG} >Adicionar grupo</div>),
                         key: '15'
                    }
               ]
          },
          {
               label: 'Visualizar',
               key: '16',
               children: [
                    {
                         label: 'Modelos de etiqueta',
                         key: '17'
                    },
                    {
                         label: 'Lista de imagens',
                         key: '18'
                    },
                    {
                         label: 'Lista de informações',
                         key: '19'
                    },
                    {
                         label: 'Impressão',
                         key: '20'
                    },
                    {
                         label: 'Barra de ferramentas',
                         key: '21'
                    }
               ]
          },
     ];

     function downloadBlob(blob, filename) {

          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = filename;

          document.body.appendChild(link);

          link.dispatchEvent(
               new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
               })
          );

          document.body.removeChild(link);
          // console.log(a);
          // console.log(document);
          // document.appendChild(a);
          // a.click();
          // document.removeChild(a);

          // const objectUrl = URL.createObjectURL(blob);

          // console.log(objectUrl);

          // const link = document.createElement("a");
          // link.href = objectUrl;
          // link.download = filename;
          // //document.body.appendChild(link);
          // link.click();
          //document.body.removeChild(link);

          //setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
          // const url = URL.createObjectURL(blob);
          // //const a = document.createElement('a');
          // let a = document.getElementById('svg_download');
          // a.href = url;
          // a.download = filename;
          // console.log(a);
          // console.log(document);
          // document.appendChild(a);
          // a.click();
          // document.removeChild(a);

     }

     const downloadSVGModel = () => {
          let file = new Blob([xmlSerializer.serializeToString(svgNodes)], { type: 'image/svg+xml' });
          const url = URL.createObjectURL(file);

          myElementRef.current.href = url;
          myElementRef.current.download = 'download.svg';
          myElementRef.current.click();
          URL.revokeObjectURL(url); // Libera o objeto URL
     }

     const arrIndex = (find) => {
          var index = -1
          for (var i = 0; i < selectedElement.length; i++) {
               if (selectedElement[i].id === find) {
                    index = i;
                    break;
               }
          }
          return index
     }

     const handleSvgChange = (event) => {
          const svgCode = event.target.value;
          setSvgCode(svgCode);
          svg.clear();
          svg.svg(svgCode);
     };

     const handleElementClick = (event) => {
          //elClick(event);          
     };

     const elClick = (event) => {
          //console.log("Click")

          let sel_items = [];
          const target = event.target;
          if (/*target.nodeName === 'svg' || */ target.nodeName === 'rect' || target.nodeName === 'circle' || target.nodeName === 'text') {

               if (event.ctrlKey) {
                    for (let i = 0; i < selectedElement.length; i++) {
                         sel_items.push(
                              selectedElement[i]
                         );
                    }

                    let index = arrIndex(target.id);
                    if (index !== -1) {
                         sel_items.splice(index, 1);
                    } else {
                         sel_items.push(
                              target.id
                         );
                    }
               } else {
                    //console.log('CTRL button was not pressed.');
                    sel_items.push(
                         target.id
                    );
               }
          }
          setSelectedElement(sel_items);
     }

     const handleMouseDown = (event) => {
          elClick(event);
          //console.log("Down")

          //elClick(event); 


          if (selectedElement) {
               setDragging(true);
               //setDragX(event.clientX);
               //setDragY(event.clientY);

               dragX = event.clientX;
               dragY = event.clientY;
               //console.log(dragX,dragY)

               //const svgElement = svg.select(`#${selectedElement}`);
               // const svgElement = document.getElementById(selectedElement[0]);
               // console.log(document.getElementById(selectedElement[0]));
               // const currentX = parseFloat(svgElement.getAttribute('x')) || 0;
               // const currentY = parseFloat(svgElement.y) || 0;
               // console.log("currentX", currentX)
               // if (!isNaN(currentX) && !isNaN(dragX) && !isNaN(event.clientX)) {
               //      console.log("currentX", currentX)
               //      //setDragX(parseFloat(svgElement.attr('x')));
               //      //setDragY(parseFloat(svgElement.attr('y')));
               //      setDragX(parseFloat(svgElement.getAttribute('x')));
               //      setDragY(parseFloat(svgElement.getAttribute('y')));
               // } else {
               //      setDragX(event.clientX - dragX);
               //      setDragY(event.clientY - dragY);
               // }




               //console.log(svgElement.attr('x'))


          }
     };

     //   const handleMouseMove = (event) => {
     //     if (dragging) {
     //       const x = event.clientX - dragX;
     //       const y = event.clientY - dragY;
     //       selectedElement.attr('x', x);
     //       selectedElement.attr('y', y);
     //     }
     //   };
     const handleMouseMove = (event) => {
          if (dragging) {
               const x = event.clientX - dragX;
               const y = event.clientY - dragY;
               console.log("event.clientX: ", event.clientX, " - dragX: ", dragX)

               for (let i = 0; i < selectedElement.length; i++) {
                    const svgElement = svg.select(`#${selectedElement[i].id}`);
                    if (svgElement) {

                         const currentX = selectedElement[i].type === 'circle' ? selectedElement[i].cx : selectedElement[i].x;
                         const currentY = selectedElement[i].type === 'circle' ? selectedElement[i].cy : selectedElement[i].y;
                         console.log(currentX, currentY, event.clientX, event.clientY);
                         //      const currentX = parseFloat(svgElement.attr('x'));
                         //      const currentY = parseFloat(svgElement.attr('y'));

                         const newX = parseFloat(currentX) + x;
                         const newY = parseFloat(currentY) + y;
                         console.log('new', newX, newY);
                         svgElement.attr({
                              x: newX,
                              y: newY
                         });

                         //      setDragX(event.clientX);
                         //      setDragY(event.clientY);
                    }
               }

               dragX = event.clientX;
               dragY = event.clientY;
               //console.log(dragX,dragY)


               //console.log("X: ",x," - Y: ",y)
               //const svgElement = svg.select(selectedElement);
               //let svgElement = document.getElementById(selectedElement);
               const svgElement = svg.select(`#${selectedElement[0]}`);
               //console.log(svgElement)
               if (svgElement) {
                    //      const currentX = parseFloat(svgElement.attr('x'));
                    //      const currentY = parseFloat(svgElement.attr('y'));

                    //      const newX = currentX + (event.clientX - dragX);
                    //      const newY = currentY + (event.clientY - dragY);
                    // svgElement.attr(...{
                    //      x: x,
                    //      y: y
                    // });

                    //      setDragX(event.clientX);
                    //      setDragY(event.clientY);
               }
          }
     };

     const handleMouseUp = () => {
          //console.log("Up")
          setDragging(false);
          //setSelectedElement([]);
          //updateProperties();
     };

     const updateProperties = () => {

          let prop_list = [];
          setPropertiesTab(prop_list);

          if (selectedElement.length === 1) {
               const svgElement = svgNodes.getElementById(selectedElement[0]);
               //console.log(`Node: ${svgElement.nodeName}, Attributes: ${svgElement.attributes?.length > 0 ? Array.from(svgElement.attributes).map(attr => `${attr.name}="${attr.value}"`).join(', ') : 'None'}`);
               let idx_key = 0;
               if (svgElement) {

                    Array.from(svgElement.attributes).map(attr => {
                         //`${attr.name}="${attr.value}"`
                         prop_list.push(
                              {
                                   key: idx_key,
                                   property: attr.name,
                                   valor: attr.value,
                                   type: 'string'
                              }
                         );

                         idx_key++;
                    })
                    if (svgElement.nodeName == "text") {
                         prop_list.push(
                              {
                                   key: idx_key,
                                   property: 'text',
                                   valor: svgElement.innerHTML,
                                   type: 'string'
                              }
                         );
                    }
               }


               /*for (let i = 0; i < properties_tab.svg_elements.length; i++) {
                    if (properties_tab.svg_elements[i].id === selectedElement[0]) {

                         let el = properties_tab.svg_elements[i];
                         console.log('el', el);
                         if (el.type == 'rect') {
                              prop_list.push(
                                   {
                                        key: '0',
                                        property: 'id',
                                        valor: el.id,
                                        type: 'string'
                                   },
                                   {
                                        key: '1',
                                        property: 'name',
                                        valor: el.name,
                                        type: 'string'
                                   },
                                   {
                                        key: '2',
                                        property: 'x',
                                        valor: el.x,
                                        type: 'number'
                                   },
                                   {
                                        key: '3',
                                        property: 'y',
                                        valor: el.y,
                                        type: 'number'
                                   },
                                   {
                                        key: '4',
                                        property: 'width',
                                        valor: el.width,
                                        type: 'number'
                                   },
                                   {
                                        key: '5',
                                        property: 'height',
                                        valor: el.height,
                                        type: 'number'
                                   },
                                   {
                                        key: '6',
                                        property: 'stroke',
                                        valor: el.stroke,
                                        type: 'color'
                                   },
                                   {
                                        key: '7',
                                        property: 'stroke-width',
                                        valor: el.strokeWidth,
                                        type: 'number'
                                   },
                                   {
                                        key: '8',
                                        property: 'fill',
                                        valor: el.fill,
                                        type: 'color'
                                   }
                              );
                         } else if (el.type === 'circle') {
                              prop_list.push(
                                   {
                                        key: '0',
                                        property: 'id',
                                        valor: el.id,
                                        type: 'string'
                                   },
                                   {
                                        key: '1',
                                        property: 'name',
                                        valor: el.name,
                                        type: 'string'
                                   },
                                   {
                                        key: '2',
                                        property: 'cx',
                                        valor: el.cx,
                                        type: 'number'
                                   },
                                   {
                                        key: '3',
                                        property: 'cy',
                                        valor: el.cy,
                                        type: 'number'
                                   },
                                   {
                                        key: '4',
                                        property: 'r',
                                        valor: el.r,
                                        type: 'number'
                                   },
                                   {
                                        key: '6',
                                        property: 'stroke',
                                        valor: el.stroke,
                                        type: 'color'
                                   },
                                   {
                                        key: '7',
                                        property: 'stroke-width',
                                        valor: el.strokeWidth,
                                        type: 'number'
                                   },
                                   {
                                        key: '8',
                                        property: 'fill',
                                        valor: el.fill,
                                        type: 'color'
                                   }
                              );
                         } else if (el.type === "text") {
                              prop_list.push(
                                   {
                                        key: '0',
                                        property: 'id',
                                        valor: el.id,
                                        type: 'string'
                                   },
                                   {
                                        key: '1',
                                        property: 'name',
                                        valor: el.name,
                                        type: 'string'
                                   },
                                   {
                                        key: '2',
                                        property: 'x',
                                        valor: el.x,
                                        type: 'number'
                                   },
                                   {
                                        key: '3',
                                        property: 'y',
                                        valor: el.y,
                                        type: 'number'
                                   },
                                   {
                                        key: '4',
                                        property: 'width',
                                        valor: el.width,
                                        type: 'number'
                                   },
                                   {
                                        key: '5',
                                        property: 'height',
                                        valor: el.height,
                                        type: 'number'
                                   },
                                   {
                                        key: '6',
                                        property: 'stroke',
                                        valor: el.stroke,
                                        type: 'color'
                                   },
                                   {
                                        key: '7',
                                        property: 'stroke-width',
                                        valor: el.strokeWidth,
                                        type: 'number'
                                   },
                                   {
                                        key: '8',
                                        property: 'fill',
                                        valor: el.fill,
                                        type: 'color'
                                   }
                              );
                         }
                    }
               }*/
          }
          setPropertiesTab(prop_list);
     }

     const onDrop = (info) => {
          //console.log(info);
          const dropKey = info.node.key;
          const dragKey = info.dragNode.key;
          const dropPos = info.node.pos.split('-');
          const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]); // the drop position relative to the drop node, inside 0, top -1, bottom 1

          const loop = (data, key, callback) => {
               for (let i = 0; i < data.length; i++) {
                    if (data[i].key === key) {
                         return callback(data[i], i, data);
                    }
                    if (data[i].children) {
                         loop(data[i].children, key, callback);
                    }
               }
          };
          const data = [...svg_elements_tab];

          // Find dragObject
          let dragObj;
          loop(data, dragKey, (item, index, arr) => {
               arr.splice(index, 1);
               dragObj = item;
          });
          if (!info.dropToGap) {
               // Drop on the content
               loop(data, dropKey, (item) => {
                    item.children = item.children || [];
                    // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                    item.children.unshift(dragObj);
               });
          } else {
               let ar = [];
               let i;
               loop(data, dropKey, (_item, index, arr) => {
                    ar = arr;
                    i = index;
               });
               if (dropPosition === -1) {
                    // Drop on the top of the drop node
                    ar.splice(i, 0, dragObj);
               } else {
                    // Drop on the bottom of the drop node
                    ar.splice(i + 1, 0, dragObj);
               }
          }
          setSvgElementsTab(data)
     };

     const onSelect = (selectedKeys, info) => {
          selectElement(info.node.id);
     };

     const columns = [
          {
               title: 'Propriedade',
               dataIndex: 'property',
               align: 'center',
               key: 'property',
          },
          {
               title: 'Valor',
               dataIndex: 'valor',
               align: 'center',
               key: 'valor',
               render: (_, record) => {

                    const field_type = getFieldType(record.property);

                    if (field_type === 'number') {
                         return (<InputNumber size="small" value={record.valor} name={record.property} onChange={(value) => updatePropInputNumber(value, record.property)} />)
                    } else if (field_type === 'color') {
                         return (<ColorPicker format="hex" size="small" value={record.valor} name={record.property} onChange={(value) => updatePropInputColor(value, record.property)} onChangeComplete={(value) => updatePropInputColor(value, record.property)} showText />)
                    } else if (field_type === 'string') {
                         return (<Input size="small" value={record.valor} name={record.property} disabled={record.property == "id"} onChange={(e) => updatePropInput(e)} />)
                    } else {
                         return (<>Erro</>)
                    }
               }
          },

     ];

     const tab_prop_items = [
          {
               label: 'Propriedades',
               key: '1',
               children: (
                    <Table
                         columns={columns}
                         dataSource={properties_tab}
                         pagination={{ pageSize: 50, size: "small", hideOnSinglePage: true/*,showSizeChanger: true */ }}
                         size="small"
                    //onChange={onChangeProp}
                    />
               )
          },
          {
               label: 'Elementos',
               key: '2',
               children: (
                    <>
                         <Button icon={<DragOutlined style={{ color: enable_drag ? "#000000" : "#DDDDDD" }} />} onClick={() => { setEnableDrag(!enable_drag) }} />
                         <Tree
                              className="draggable-tree"
                              defaultExpandAll={true}
                              //defaultExpandedKeys={expandedKeys}
                              draggable={enable_drag}
                              showLine
                              blockNode
                              onSelect={onSelect}
                              //onDragEnter={onDragEnter}
                              onDrop={onDrop}
                              treeData={svg_elements_tab}
                         />
                    </>

               ),
          },
     ];



     const onChange = (value) => {
          if (Number.isNaN(value)) {
               return;
          }
          setInputValue(value);
     };

     const SvgComponentPDF = ({ svgNodes }) => {
          const [svgNodesSt, setSvgNodesSt] = useState(svgNodes);
     
          useEffect(() => {
               setSvgNodesSt(svgNodes)        
          }, [svgNodes]);
     
          const renderNode = (node) => {
               // Se o nó for um elemento, renderiza como um elemento do react-pdf
               if (node.nodeType === Node.ELEMENT_NODE) {
               const children = Array.from(node.childNodes).map(renderNode); // Renderiza os filhos recursivamente
               const attributes = Array.from(node.attributes).reduce((attrs, attr) => {
                    // Converte atributos para um objeto
                    const name = attr.name;
                    const value = attr.value;
          
                    // Converte atributos SVG para camelCase
                    const camelCasedName = name.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
                    attrs[camelCasedName] = value;
          
                    return attrs;
               }, {});
          
               // Se o nó for um elemento <text> e tiver o ID "TXT1", adiciona a fonte Arial
               if (node.nodeName.toLowerCase() === 'text' && node.id === 'TXT1') {
                    attributes.fontFamily = 'Arial'; // Adiciona a fonte Arial
               }
          
               // Renderiza o nó como um componente do react-pdf
               switch (node.nodeName.toLowerCase()) {
                    case 'svg':
                         return <Svg {...attributes}>{children}</Svg>;
                    case 'text':
                         return <Text {...attributes}>{node.innerText}</Text>;
                    case 'rect':
                         return <Rect {...attributes} />;
                    // Adicione outros elementos SVG conforme necessário
                    default:
                         return React.createElement(node.nodeName.toLowerCase(), attributes, ...children);
               }
               } else if (node.nodeType === Node.TEXT_NODE) {
               // Se o nó for um texto, retorna o texto
               return node.nodeValue; // Retorna o texto contido no nó
               }
               return null; // Ignora outros tipos de nós
          };
     }

     const MyDocument = () => (
          <Document>
               <Page size="A4" style={styles.page}>
                    <View>
                         {/* <SvgComponent2 /> */}
                         <SvgComponentPDF svgNodes={svgNodes}/>
                         {/* <SvgComponent svgNodes={svgNodes} /> */}
                    </View>
                    <View>
                         {/* <SvgComponent2 /> */}
                         <SvgComponentPDF svgNodes={svgNodes}/>
                         {/* <SvgComponent svgNodes={svgNodes} /> */}
                    </View>
               </Page>
               {/* <Page size="A4" style={styles.page2}>
                    <View style={styles.rectangle} />
                    <View style={styles.CutContour} />
                    <Path
                         d="M 50 100 L 550 100"
                         style={styles.CutContour}
                         />
                    <Path d="M0 0 L200 0 L200 100 L0 100 Z" fillRule="evenodd" strokeWidth="0.25" fill="none rgb-icc(#Separation, 'CutContour')" color="CutContour" stroke="rgb(0,255,0) icc-color(#CMYK, 26%, 50%, 99%, 24%)" />
                    <Text style={styles.text}>Linha de CutContour</Text>
               </Page> */}
          </Document>
     );

     const tab_content_items = [
          {
               label: 'Modelos',
               key: '1',
               children: (
                    <Layout style={{ minHeight: '80vh', border: '1px solid #006EDF' }}>
                         <Flex wrap gap="small" justify="center" style={{ marginTop: '10px' }}>
                              {
                                   svgModels.map((card, index) =>
                                        (<Card key={index + 1} title={card.title} info={card.info} onUpdateValue={handleUpdatePage} />)
                                   )}
                         </Flex>
                    </Layout>
               )
          },
          {
               label: 'Imagens',
               key: '2',
               children: (
                    <Layout style={{ minHeight: '80vh', border: '1px solid #006EDF' }}></Layout>
               )
          },
          {
               label: 'Edição',
               key: '3',
               children: (
                    <Layout style={{ minHeight: '80vh', border: '1px solid #006EDF' }}>
                         <Layout>
                              <Flex wrap vertical={false}>
                                   <Button onClick={addRectSVG}><BorderOutlined /></Button>
                                   <Button onClick={addCircleSVG}><MinusCircleOutlined  /></Button>
                                   <Button><LineOutlined  /></Button>
                                   <Button onClick={addTextSVG}><FontSizeOutlined  /></Button>
                                   <Button><QrcodeOutlined /></Button>
                                   <Button><BarcodeOutlined /></Button>
                                   <Button><DeleteOutlined /></Button>
                                   <Button><DragOutlined /></Button>



                                   <Button><ToolOutlined /></Button>
                                   <Button onClick={downloadSVGModel}><DownloadOutlined /></Button>
                                   

                              </Flex>
                              <Content style={contentStyle}>

                                   {/* <svg id="svg" width="800" height="400" onClick={handleElementClick} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} /> */}
                                   <div style={{ transform: `scale(${inputValue})`, transformOrigin: "left top" }}>
                                        <SvgComponent svgNodes={svgNodes} />
                                   </div>
                              </Content>
                              <Row>
                                   <Col span={12}>
                                        <Slider
                                             min={0.1}
                                             max={3}
                                             onChange={onChange}
                                             value={typeof inputValue === 'number' ? inputValue : 0.1}
                                             step={0.1}
                                        />
                                   </Col>
                                   <Col span={4}>
                                        <InputNumber
                                             min={0.1}
                                             max={3}
                                             style={{
                                                  margin: '0 16px',
                                             }}
                                             step={0.1}
                                             value={inputValue}
                                             onChange={onChange}
                                        />
                                   </Col>
                              </Row>
                         </Layout>
                         <Sider
                              breakpoint="lg"
                              collapsedWidth="0"
                              width="260"
                              height="100%"
                              style={{
                                   //overflow: 'auto',
                                   //height: '100vh',
                                   //position: 'fixed',
                                   position: broken ? 'fixed' : 'relative',
                                   zIndex: 1,
                                   right: 0,
                                   top: broken ? 65 : 0,
                                   bottom: 0,
                                   backgroundColor: "white",
                                   border: '1px solid #006EDF'
                              }}
                              trigger={null}
                              collapsed={collapsed}
                              onBreakpoint={(broken) => {
                                   //console.log('broken',broken);
                                   setBroken(broken);
                                   setCollapsed(broken);
                              }}
                              onCollapse={(collapsed, type) => {
                                   //console.log(collapsed, type);
                                   setCollapsed(collapsed);
                              }}
                         >
                              <Tabs
                                   type="card"
                                   size="small"
                                   items={tab_prop_items}
                              />
                         </Sider>
                    </Layout>
               ),
          },
          {
               label: 'Informações',
               key: '4',
               children: (
                    <Layout style={{ minHeight: '80vh', border: '1px solid #006EDF' }}></Layout>
               ),
          },
          {
               label: 'Impressão',
               key: '5',
               children: (
                    <Layout style={{ minHeight: '80vh', border: '1px solid #006EDF' }}>
                         <Flex wrap vertical={false}>

                              <PDFDownloadLink document={<MyDocument />} fileName="etiquetas.pdf">
                                   {({ loading }) => (loading ? 'Carregando documento...' : <Button><DownloadOutlined /></Button>)}
                              </PDFDownloadLink>
                         </Flex>
                         <PDFViewer style={{ width: '100%', height: '100vh' }}>
                              <MyDocument />
                         </PDFViewer>
                    </Layout>
               ),
          },
     ];

     const onClick = (e) => {
          //console.log('click ', e);
          setCurrent(e.key);
     };

     return (
          <>
               <Layout style={{ width: '100%', minHeight: '80vh', position: full_view ? "fixed" : null, top: full_view ? 0 : null, left: full_view ? 0 : null, zIndex: full_view ? 2000 : null }}>
                    {/* <Header style={headerStyle}>
                         <Flex vertical={false}>
                              <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} style={{ flex: 1, width: '100%', float: "left" }} />
                         </Flex>
                    </Header> */}
                    {/* <Header style={headerStyle}> */}
                    {/* <Flex wrap vertical={false}>
                         <Button><DeleteOutlined /></Button>
                         <Button><DragOutlined /></Button>
                         <Button><FontSizeOutlined /></Button>
                         <Button><BarcodeOutlined /></Button>
                         <Button><BorderOutlined /></Button>
                         <Button><LineOutlined /></Button>
                         <Button><ToolOutlined /></Button>
                         <Button><QrcodeOutlined /></Button>
                         <Button><MinusCircleOutlined /></Button>
                    </Flex> */}
                    {/* </Header> */}
                    {/* <Layout> */}
                    <Tabs
                         //defaultActiveKey={"1"}
                         //activeKey={current}
                         type="card"
                         size="small"
                         items={tab_content_items}
                         style={tab_style}
                         onChange={(e) => {return setCurrent(e.key)}}
                         onTabClick={(e) => {return setCurrent(e.key)}}
                    />
                    {broken &&
                         <ConfigProvider
                              theme={{
                                   token: {
                                        fontSizeIcon: 20
                                   },
                              }}
                         >
                              <FloatButton
                                   style={{
                                        position: 'fixed',
                                        zIndex: 2000,
                                        bottom: 106,
                                        right: 26,
                                        height: 60,
                                        width: 60
                                   }}
                                   icon={collapsed ? <ToolOutlined /> : <ToolOutlined />}
                                   onClick={() => setCollapsed(!collapsed)}
                              />
                         </ConfigProvider>
                    }
               </Layout>
               <a ref={myElementRef}></a>
          </>
     )
}

export default TLSEtiquetas;